// src/data/awards.js
const AWARDS = [
  "IBM Outcome Focused Recognition — 500 BluePoints",
  "IBM Growth Award ($500)",
  "IBM Excellence Award ($125)",
  "Multiple TCS Gems awards",
  "Wipro Victory League recognition",
];

export { AWARDS };
export default AWARDS;
